import React from 'react';
import ReactModal from 'react-modal';

const Modal = React.createClass({

  getInitialState: function() {
    return {
      style: {
        display: null
      },
      shareStyle: {
        display: 'none'
      }
    };
  },

  componentWillReceiveProps: function() {
    this.setState(this.getInitialState());
  },

  render: function() {
    return (
      <ReactModal
        overlayClassName="abl-modal"
        className="abl-modal-content"
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onClose}
      >
        <div className="abl-share-export-modal">
          <div style={this.state.style}>
            <img 
              src={require('../../../img/share_and_export_fpo.png')}
              width="562"
              height="360"
              alt="Share and Export" />
              <span onClick={this.handleShareClick} className="abl-share-btn"></span>
          </div>
          <div className="abl-share-modal" style={this.state.shareStyle}>
            <img 
              src={require('../../../img/share_modal_fpo.png')}
              width="642"
              height="350"
              alt="Share" />
          </div>
          <span onClick={this.props.onClose} className="abl-close-btn"></span>
        </div>
      </ReactModal>
    );
  },

  handleShareClick: function() {
    this.setState({
      style: { display: 'none' },
      shareStyle: { display: 'block' }
    })
  }

});

export default Modal;


/** WEBPACK FOOTER **
 ** ./src/js/components/modal.js
 **/